import { Injectable } from '@angular/core';

import { FormService, FormValues } from '@alfresco/adf-core';

@Injectable({
  providedIn: 'root',
})
export class WkFormService {
  constructor(private readonly formService: FormService) {}

  parseForm(
    json: any,
    data: FormValues = null,
    readonly = false,
    fixedSpace = false
  ) {
    return this.formService.parseForm(json, data, readonly, fixedSpace);
  }
}
